import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import axios from "axios";
import { Baseurl } from "../../config/BaseUrl";
import {
  setPropertybySubcatStatus,
  setPropertyfilterbySubcat,
} from "../../redux/property/PropertySlice";
import { 
  FaBuilding, 
  FaMapMarkedAlt, 
  FaHome, 
  FaLayerGroup 
} from "react-icons/fa";
import { FiArrowUpRight, FiLayers } from "react-icons/fi";
import "./ApartmentsVillasNew.css";

function ApartmentsVillas() {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const supcat = "Residential";
  const cat = "Rent";
  const city = "Hyderabad";

  const [apartmentCount, setApartmentCount] = useState([]);
  const [landCount, setLandCount] = useState([]);
  const [villaCount, setVillaCount] = useState([]);
  const [independentHouseCount, setIndependentHouseCount] = useState([]);

  useEffect(() => {
    const fetchAllCounts = async () => {
      try {
        const requests = [
          axios.get(`${Baseurl}/api/v1/property/propertybycityandsubcat/${city}/${supcat}/Apartment`),
          axios.get(`${Baseurl}/api/v1/property/propertybycityandsubcat/${city}/${supcat}/Land`),
          axios.get(`${Baseurl}/api/v1/property/propertybycityandsubcat/${city}/${supcat}/Villa`),
          axios.get(`${Baseurl}/api/v1/property/propertybycityandsubcat/${city}/${supcat}/Independent House`),
        ];

        const results = await Promise.allSettled(requests);

        if (results[0].status === "fulfilled" && results[0].value.data?.success) {
          setApartmentCount(results[0].value.data.propertybycity || []);
        }
        if (results[1].status === "fulfilled" && results[1].value.data?.success) {
          setLandCount(results[1].value.data.propertybycity || []);
        }
        if (results[2].status === "fulfilled" && results[2].value.data?.success) {
          setVillaCount(results[2].value.data.propertybycity || []);
        }
        if (results[3].status === "fulfilled" && results[3].value.data?.success) {
          setIndependentHouseCount(results[3].value.data.propertybycity || []);
        }
      } catch (error) {
        // Fallbacks rendered seamlessly
      }
    };

    fetchAllCounts();
  }, [city, supcat]);

  const handleCategoryClick = (subcatParam, dataList) => {
    dispatch(setPropertybySubcatStatus(true));
    dispatch(setPropertyfilterbySubcat(dataList));
    navigate(`/property-search/${supcat}/${cat}/${encodeURIComponent(subcatParam)}/${city}`);
  };

  const categories = [
    {
      id: "apartment",
      title: "Residential Apartment",
      tagline: "Flats & High-rise living",
      subcatParam: "Apartment",
      count: `${apartmentCount.length > 0 ? apartmentCount.length : 1}+ Properties`,
      badge: "Apartments",
      image: "/assets/images/category/apartment_card.jpg",
      fallbackImage: "/assets/images/sliderImg/d_hp_property_type_1.webp",
      themeClass: "mgh-cat-rose",
      icon: <FaBuilding />,
      dataList: apartmentCount,
    },
    {
      id: "land",
      title: "Residential Land",
      tagline: "Plots & Investment plots",
      subcatParam: "Land",
      count: `${landCount.length > 0 ? landCount.length : 30}+ Properties`,
      badge: "Plots & Land",
      image: "/assets/images/category/land_card.jpg",
      fallbackImage: "/assets/images/sliderImg/d_hp_property_type_3.webp",
      themeClass: "mgh-cat-blue",
      icon: <FaMapMarkedAlt />,
      dataList: landCount,
    },
    {
      id: "villa",
      title: "Independent Villa",
      tagline: "Luxury gated community",
      subcatParam: "Villa",
      count: `${villaCount.length > 0 ? villaCount.length : 30}+ Properties`,
      badge: "Luxury Villas",
      image: "/assets/images/category/villa_card.jpg",
      fallbackImage: "/assets/images/sliderImg/d_hp_property_type_2.webp",
      themeClass: "mgh-cat-green",
      icon: <FaHome />,
      dataList: villaCount,
    },
    {
      id: "builder-floor",
      title: "Builder Floor",
      tagline: "Independent floor units",
      subcatParam: "Independent House",
      count: `${independentHouseCount.length > 0 ? independentHouseCount.length : 25}+ Properties`,
      badge: "Builder Floors",
      image: "/assets/images/category/builder_floor_card.jpg",
      fallbackImage: "/assets/images/sliderImg/d_hp_property_type_4_1.png",
      themeClass: "mgh-cat-amber",
      icon: <FaLayerGroup />,
      dataList: independentHouseCount,
    },
  ];

  return (
    <section className="mgh-category-section" aria-label="Explore Properties by Category">
      {/* Header Area */}
      <div className="mgh-cat-header">
        <div className="mgh-cat-header-left">
          <div className="mgh-cat-eyebrow">
            <span>EXPLORE BY CATEGORY</span>
            <span className="mgh-cat-eyebrow-line"></span>
          </div>
          <h2 className="mgh-cat-title">
            Apartments, <span className="mgh-cat-highlight">Villas</span> and more
          </h2>
          <p className="mgh-cat-subtitle">
            Discover the best residential and investment properties in {city}.
          </p>
        </div>

        {/* Decorative Graphic matching Reference */}
        <div className="mgh-cat-header-right" aria-hidden="true">
          <div className="mgh-cat-script-wrap">
            <span className="mgh-cat-script-text">
              Find Your<br />Perfect Property
            </span>
            <svg className="mgh-cat-script-arrow" viewBox="0 0 60 40" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M5 20 C 18 2, 42 2, 52 24" stroke="#e58325" strokeWidth="2.6" strokeLinecap="round" fill="none" />
              <path d="M44 20 L 52 25 L 54 15" stroke="#e58325" strokeWidth="2.6" strokeLinecap="round" strokeLinejoin="round" fill="none" />
            </svg>
          </div>
          <div className="mgh-cat-decor-building-wrap">
            <div className="mgh-cat-decor-sun"></div>
            <img
              src="/assets/images/category/header_villa_decor.jpg"
              alt=""
              className="mgh-cat-decor-building"
            />
            <div className="mgh-cat-decor-cloud-fade"></div>
          </div>
        </div>
      </div>

      {/* 4 Clean Category Cards */}
      <div className="mgh-cat-grid">
        {categories.map((catItem) => (
          <div
            key={catItem.id}
            className={`mgh-cat-card ${catItem.themeClass}`}
            onClick={() => handleCategoryClick(catItem.subcatParam, catItem.dataList)}
            role="button"
            tabIndex={0}
            onKeyDown={(e) => {
              if (e.key === "Enter" || e.key === " ") {
                handleCategoryClick(catItem.subcatParam, catItem.dataList);
              }
            }}
          >
            {/* Top Photo Viewport */}
            <div className="mgh-cat-img-wrap">
              <img
                src={catItem.image}
                alt={catItem.title}
                className="mgh-cat-img"
                loading="lazy"
                onError={(e) => {
                  e.target.src = catItem.fallbackImage;
                }}
              />
              <div className="mgh-cat-img-overlay"></div>

              {/* Top Floating Badge */}
              <div className="mgh-cat-floating-badge">
                <FiLayers className="mgh-cat-badge-icon" />
                <span>{catItem.badge}</span>
              </div>

              {/* Top Right Action Arrow */}
              <div className="mgh-cat-arrow-btn" aria-label={`View ${catItem.title}`}>
                <FiArrowUpRight />
              </div>
            </div>

            {/* Card Body */}
            <div className="mgh-cat-card-body">
              <div className="mgh-cat-title-row">
                <div className="mgh-cat-icon-circle" aria-hidden="true">
                  {catItem.icon}
                </div>
                <div className="mgh-cat-title-text">
                  <h3 className="mgh-cat-title-label">{catItem.title}</h3>
                  <span className="mgh-cat-tagline">{catItem.tagline}</span>
                </div>
              </div>

              {/* Bottom Count Row */}
              <div className="mgh-cat-bottom-row">
                <span className="mgh-cat-count-pill">{catItem.count}</span>
                <span className="mgh-cat-city-tag">Hyderabad</span>
              </div>
            </div>

            {/* Bottom Accent Line */}
            <div className="mgh-cat-accent-line"></div>
          </div>
        ))}
      </div>
    </section>
  );
}

export default ApartmentsVillas;
